import { createContext, useContext } from 'react';

export const ProjectDemoContext = createContext(false);

export const useIsProjectDemo = () => useContext(ProjectDemoContext);
